const targetedDbFlashFormInitialValues = () => ({ dishTypeIds: [] })

export default targetedDbFlashFormInitialValues
